import { initSentry } from './utils/sentry';

// 接入Sentry监控
initSentry();

// 到达指定时间点后刷新已打开的页面（获取最新代码/配置）
// 正式：北京时间（UTC+8）2026-10-01 00:00:00
const REFRESH_AT = new Date('2026-10-01T00:00:00+08:00').getTime();
// const REFRESH_AT = new Date('2026-09-18T11:47:00+08:00').getTime();
const scheduleRefreshAt = () => {
  const delay = REFRESH_AT - Date.now();
  // 已过刷新时间点（页面在此之后打开），无需刷新
  if (delay <= 0) return;
  // setTimeout 延迟为 32 位有符号整数，超出会溢出，分段等待
  const MAX_DELAY = 2 ** 31 - 1;
  if (delay > MAX_DELAY) {
    setTimeout(scheduleRefreshAt, MAX_DELAY);
  } else {
    setTimeout(() => {
      window.location.reload();
    }, delay);
  }
};
scheduleRefreshAt();

const isHttps = document.location.protocol === 'https:';
if ('serviceWorker' in navigator && isHttps) {
  // unregister service worker
  const { serviceWorker } = navigator;
  if (serviceWorker.getRegistrations) {
    serviceWorker.getRegistrations().then((sws) => {
      sws.forEach((sw) => {
        sw.unregister();
      });
    });
  }
  serviceWorker.getRegistration().then((sw) => {
    if (sw) sw.unregister();
  });

  // remove all caches
  // @ts-ignore
  if (window.caches && window.caches.keys()) {
    caches.keys().then((keys) => {
      keys.forEach((key) => {
        caches.delete(key);
      });
    });
  }
}
